<template>
    <div>
        <div class="text-[1.5rem] text-primary text-left py-4">
            親愛的客戶您好<br>
            為辦理給付帳號約定變更，須先確認身分，下一步將進行行動身分識別<br>
            請確認符合以下條件：<br>
            <ol class="h2 list-decimal ml-6 pb-12 pad:px-4 md:px-0">
                <li>您目前的手機門號是您本人申辦之個人4G/5G月租型門號</li>
                <li>門號之電信業者為中華電信、台灣大哥大、台灣之星、亞太電信或遠傳電信其中任一家。請先關閉WIFI，以4G/5G網路連線。</li>
            </ol>
        </div>
        <div class="flex justify-center pt-2">
            <button
                class="btn w-full rounded-full gradient-primary border-0 max-w-[8.75rem]"
                @click.prevent="postApi"
            >
                同意並下一步
            </button>
        </div>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';
import routeName from '@/router/constant.js';
export default {

    setup() {
        const router = useRouter();

        const postApi = () => {
            router.push({ name: routeName.TWID_MOBILE });
        };

        return {
            postApi,
        };
    }
};

</script>
